import { titleize } from 'underscore.string';
import { unescapeSpecialChars } from 'helpers/helper_functions';
export function getCustomerName(user = {}) {
    let name = '';
    if ((user === null || user === void 0 ? void 0 : user._type) === 'Shipper') {
        name = user === null || user === void 0 ? void 0 : user.company_name;
    }
    else if ((user === null || user === void 0 ? void 0 : user._type) === 'Carrier') {
        name = user === null || user === void 0 ? void 0 : user.name;
    }
    else if ((user === null || user === void 0 ? void 0 : user._type) === 'Consignee') {
        name = user === null || user === void 0 ? void 0 : user.company_name;
    }
    else if ((user === null || user === void 0 ? void 0 : user._type) === 'Driver') {
        name = `${user === null || user === void 0 ? void 0 : user.first_name} ${user === null || user === void 0 ? void 0 : user.last_name}`;
    }
    return unescapeSpecialChars(`${titleize(name).trim()}`);
}
